import { RecursivePartial } from "@easy-email-pro-core/typings/helper";
import { cloneDeep, isArray, mergeWith } from "lodash";

export function mergeBlock<T extends Record<string, any>>(
  a: T,
  b?: RecursivePartial<any>
): T {
  return mergeWith(cloneDeep(a), cloneDeep(b), (a, b) =>
    isArray(b) ? b : undefined
  );
}
